import { useEffect, useState } from "react";

/**
 * A media query as a boolean.
 *
 * Used where a layout is not just a rearrangement but a different component —
 * four columns on a desk, one group at a time on a phone. Tailwind can hide
 * and show, but it cannot stop React rendering twenty-five list items nobody
 * on a phone will ever scroll to.
 *
 * Starts false and corrects itself in an effect. That means one frame of the
 * mobile layout on a wide screen, which is the right way round: the mobile
 * layout is the smaller one, so nothing jumps taller after the correction.
 */
export function useMediaQuery(query) {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia(query);
    const update = () => setMatches(mq.matches);
    update();
    mq.addEventListener("change", update);
    return () => mq.removeEventListener("change", update);
  }, [query]);

  return matches;
}
